export const BU_DELETE_SIZES = [
  'small',
  'medium',
  'large'
];
